/* eslint-disable */
let DirectionEntity = Backbone.Model.extend({
	defaults: {
		cover:null,
		link:null,
		directionTitle:null,
		directionId:null,
		restTypes: null,
		price:null
	}
});

export default DirectionEntity;